module.exports = __webpack_public_path__ + "img/xu3.d24385fc.png";